










import Vue from 'vue'

export default Vue.extend({
  computed: {
    deviceClass(): {[key: string]: boolean} {
      const userAgent = window.navigator.userAgent.toLowerCase()
      const classes: {[key: string]: boolean} = {}

      if (userAgent.indexOf('msie') !== -1 ||
              userAgent.indexOf('trident') !== -1) {
          classes.is_ie = true
      } else if (userAgent.indexOf('edge') !== -1) {
          classes.is_edge = true
      } else if (userAgent.indexOf('chrome') !== -1) {
          classes.is_chrome = true
      } else if (userAgent.indexOf('safari') !== -1) {
          classes.is_safari = true
      } else if (userAgent.indexOf('firefox') !== -1) {
          classes.is_firefox = true
      } else if (userAgent.indexOf('opera') !== -1) {
          classes.is_opera = true
      } else {
          classes.is_other = true
      }

      return classes
    },
    viewLoading(): boolean {
      return this.$store.state.App.isLoading
    },
    loadingText(): string {
      return this.$store.state.App.loadingText
    }
  }
})
